<template>
  <form class="login-form" @submit.prevent="handleSubmit">
    <div class="login-header">
      <h1>Bem-vindo,</h1>
      <strong>Aluno</strong>
    </div>

    <Input
      mask="###.###.###-##"
      legend="CPF"
      placeholder="Digite seu CPF"
      :modelValue="cpf"
      @update:modelValue="$event => (cpf = $event)"
      variant="dark"
      :disabled="loading"
    />

    <div class="custom-checkbox">
      <input
        type="checkbox"
        id="termos"
        :checked="termos"
        @change="termos = $event.target.checked"
        :disabled="loading"
      />
      <span class="checkmark" @click="termos = !termos"></span>
      <label for="termos" class="label-text">
        Li e aceito os
        <span @click="openTermos()" title="Abrir termos.">termos e condições de uso</span>.
      </label>
    </div>

    <Button
      type="submit"
      :text="loading ? 'ENTRANDO...' : 'ENTRAR'"
      color="primary"
      id="btn_login"
      :disabled="loading || !termos"
    />

    <router-link class="return-link" :to="{ name: 'login', params: { autoescola: schema } }">
      <ArrowLeftThin :size="22" />
      Escolher outro login
    </router-link>

    <span>NovoCFC: {{ schema }}</span>

    <vuestic-modal
      ref="modalTermosDeUso"
      v-bind:large="true"
      :cancelClass="'none'"
      :okClass="'btn btn-primary btn-micro'"
      okText="Confirmar"
    >
      <termos></termos>
    </vuestic-modal>
  </form>
</template>

<script>
import Button from 'core/Button'
import Input from 'core/Input'

import ArrowLeftThin from 'icons/ArrowLeftThin'

import store from '../../../store'
import Termos from './termos/Aluno'

export default {
  name: 'login',
  components: {
    Input,
    Button,

    ArrowLeftThin,

    Termos,
  },
  data() {
    return {
      schema: null,
      cpf: '',
      termos: false,
      loading: false,
    }
  },
  mounted() {
    let locationArr = location.hash.split('?')

    if (locationArr.length > 1) {
      let arrParams = locationArr[1].split('=')
      if (arrParams[0] === 'cpf') {
        this.cpf = arrParams[1]
      }
    }

    const schemaStorage = localStorage.schema
    const currentParam = this.$router.currentRoute.params.autoescola

    if (
      schemaStorage &&
      schemaStorage !== 'public' &&
      schemaStorage !== 'undefined' &&
      schemaStorage !== 'null'
    ) {
      this.schema = schemaStorage
    }

    if (currentParam && currentParam !== 'public') {
      this.schema = currentParam
    } else if (this.schema) {
      this.$router.replace({
        name: this.$router.currentRoute.name,
        params: { ...this.$router.currentRoute.params, autoescola: this.schema },
        query: this.$router.currentRoute.query,
      })
    }
  },
  methods: {
    openTermos() {
      this.$refs.modalTermosDeUso.open()
    },
    async handleSubmit() {
      if (this.validateInputs()) {
        await this.login()
      }
    },
    validateInputs() {
      if (!this.cpf) {
        this.$toasted.show('Preencha o campo de CPF!', {
          icon: 'fa-times',
          position: 'top-right',
          duration: 5000,
          fullWidth: false,
        })

        return false
      }

      return true
    },
    async login() {
      localStorage.clear()

      this.loading = true

      await this.$http
        .post(`${process.env.VUE_APP_URL_API}/login/aluno`, {
          autoescola: this.schema,
          cpf: this.cpf,
          termos: this.termos,
        })
        .then(({ body }) => {
          window.localStorage['usuario'] = JSON.stringify(body.usuario)
          window.localStorage['aluno'] = JSON.stringify(body.aluno)
          window.localStorage['token'] = body.access_token
          window.localStorage['refresh_token'] = body.refresh_token
          window.localStorage['id_role'] = body.id_role
          window.localStorage['role'] = body.role
          window.localStorage['schema'] = body.schema
          window.localStorage['cfc'] = body.cfc
          window.localStorage['url'] = body.url
          window.localStorage['id'] = body.aluno.id_aluno
          window.localStorage['cpf'] = body.aluno.cpf
          window.localStorage['nome'] = body.aluno.nome
          window.localStorage['tipo_processo'] = body.aluno.tipo_processo
          window.localStorage['nome_fantasia'] = body.nome_fantasia
          window.localStorage['permissions'] = JSON.stringify(body.role.permissions)

          store.commit('authenticated')

          this.$router.push({ name: 'aulas-teoricas' })
        })
        .catch(({ body }) => {
          this.$toasted.show(body.dados, {
            icon: 'fa-times',
            position: 'top-right',
            duration: 5000,
            fullWidth: false,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.login-form {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  .login-header {
    font-size: 3rem;
    line-height: 100%;
    letter-spacing: -0.11px;
    color: #202224;

    h1 {
      font-size: 3rem;
      margin: 0;
      font-weight: 700;
    }

    strong {
      font-weight: 900;
    }
  }

  .custom-checkbox {
    display: flex;
    align-items: center;
    user-select: none;

    input {
      display: none;
    }

    .checkmark {
      width: 0.9375rem;
      height: 0.9375rem;
      border: 2px solid #707070;
      border-radius: 3px;
      background-color: transparent;
      margin-right: 0.5rem;
      box-sizing: border-box;
      transition: background-color 0.2s;
      cursor: pointer;
    }

    input:checked + .checkmark {
      background-color: #1b2c5a;
    }

    .label-text {
      margin: 0;
      font-weight: 400;
      line-height: 100%;
      letter-spacing: 0%;
      font-size: 1rem;
      color: #606264;
      cursor: pointer;

      > span {
        font-weight: 600;
        color: #1c2d5a;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  > Button {
    height: auto;
    padding: 1.25rem;
    justify-content: center;
    font-size: 1rem;
    font-family: Inter;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: 0%;
  }

  .return-link {
    all: unset;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;

    font-weight: 400;
    font-size: 1rem;
    line-height: 100%;
    letter-spacing: 0%;
    color: #1b2c5a;
    cursor: pointer;
  }

  > span {
    text-align: center;
    font-weight: 600;
    font-size: 0.75rem;
    line-height: 100%;
    letter-spacing: -0.11px;
  }
}
</style>
